import { styled } from '../theme';

const ModalFooter = styled('div')(({ theme }) => ({
    display: 'flex',
    'button:first-of-type': {
        borderRadius: '0 0 0 4px',
    },
    'button:last-child': {
        borderRadius: '0 0 4px 0',
    },
}));

export default ModalFooter;
